import { Box, Button, Fab, FormControl, InputLabel, MenuItem, Select, Skeleton, Tab, Tabs, TextField, styled, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import SftGlobalData from '../../library/SftGlobalData';
import Card from '../../components/Card';
import EditIcon from '@mui/icons-material/Edit';
import FloatingAddButton from '../../components/FloatingAddButton';
import ModalUnstyled from '@mui/base/ModalUnstyled';
import Colors from '../../library/Colors';
import { TailSpin } from 'react-loader-spinner';
import { DataGridPro } from '@mui/x-data-grid-pro';

const brokenImage = "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";
let currType = '';
function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <div style={{paddingTop: 15}}>{children}</div>
          </Box>
        )}
      </div>
    );
}
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
  
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const StyledModal = styled(ModalUnstyled)`
    position: fixed;
    text-align: center;
    z-index: 1300;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    `;

const Backdrop = styled('div')`
    z-index: -1;
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-tap-highlight-color: transparent;
    `;

const style = {
    bgcolor: 'background.paper',
    border: '0px solid #000',
    borderRadius: 6,
    p: 2,
    px: 4,
    pb: 3,
};


const getReplacementStatus = (stat) => {
    switch(stat){
        case "35000": return (<span className='green_text'>AVAILABLE</span>);
        case "35001": return (<span className='error_text'>UNAVAILABLE</span>);
        case "35002": return (<span className='error_text'>MISSING</span>);
        case "35003": return (<span className='error_text'>DEFECT</span>);
        case "35004": return (<span className='error_text'>SOLD</span>);
        case "35005": return (<span className='error_text'>DELETED</span>);
        default:
            return (<span className='green_text'>AVAILABLE</span>);
    }
}

const getRmaStatus = (stat) => {
    switch(stat){
        case "29000": return (<span className='green_text'>OPEN</span>);
        case "29001": return (<span className='green_text'>ARTICLE RECEIVED</span>);
        case "29002": return (<span className='error_text'>PROCESSED</span>);
        case "29003": return (<span className='sft_blue_text'>ARTICLE RETURNING</span>);
        case "29004": return (<span className='sft_blue_text'>REPLACEMENT RETURNING</span>);
        case "29005": return (<span className='error_text'>DELETED</span>);
        default:
            return (<span className='green_text'>OPEN</span>);
    }
}

const getSupplierStatus = (stat) => {
    switch(stat){
        case "29500": return (<span className='green_text'>OPEN</span>);
        case "29501": return (<span className='sft_blue_text'>CONTACTED</span>);
        case "29502": return (<span className='green_text'>OFFER RECEIVED</span>);
        case "29503": return (<span className='sft_blue_text'>SHIPPED</span>);
        case "29504": return (<span className='green_text'>RETURNED</span>);
        case "29505": return (<span className='error_text'>CLOSED</span>);
        default:
            return (<span className='green_text'>OPEN</span>);
    }
}

const RMAScreen = (props) =>  {  
    const [loading, setLoading] = useState(true);
    const [value, setValue] = useState(0);
    const [replacements, setReplacements] = useState([]);
    const [modalStoresOpen, setModalStoresOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [modalTarget, setModalTarget] = useState("");
    const [stores, setStores] = useState([]);
    const [selectedStore, setSelectedStore] = useState("00");
    const [searchValue, setSearchValue] = useState("");

    // Replacement stuff
    const [replacementTypes, setReplacementTypes] = useState([]);
    const [replacementName, setReplacementName] = useState("");
    const [replacementType, setReplacementType] = useState("");
    const [replacementStatus, setReplacementStatus] = useState("35000");
    const [replacementSerial, setReplacementSerial] = useState("");
    const [replacementImage, setReplacementImage] = useState("");
    const [replacementRemark, setReplacementRemark] = useState("");

    // RMA stuff
    const [rma, setRma] = useState([]);
    const [rmaClosed, setRmaClosed] = useState([]);

    // DB version
    const [dbVersion, setDbVersion] = useState(0);
    const minDB = 315;

    let navigate = useNavigate();
    const params = useParams();
    const theme = useTheme();

    const fetchDbVersion = () => {
        SftGlobalData.post('sftData', {key: props.api, type: "dbversion"}).then(response => {
            setDbVersion(parseInt(response.data.data.version));
        });
    }

    useEffect(() => {
        props.changeScreen('Licence');
        if(props.api!==""){
            if(typeof params?.search !== "undefined") setSearchValue(params?.search);
            fetchDbVersion();
            loadRmaOpen();
            loadRmaClosed();
            loadReplacements();
            loadStores();
        }
     },[props.api]);

    const loadRmaOpen = () => {
        setLoading(true);
        SftGlobalData.post('rma&action=fetch', {key: props.api, status: "open", compact: true}).then(response => {
            if(typeof response.error === 'undefined'){
                setRma(response.data);
            } else { 
                props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);
            }
            setLoading(false);
        });
    }

    const loadRmaClosed = () => {
        setLoading(true);
        SftGlobalData.post('rma&action=fetch', {key: props.api, status: "closed", compact: true}).then(response => {
            if(typeof response.error === 'undefined'){
                setRmaClosed(response.data);
            } else { 
                props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);
            }
            //setLoading(false);
        });
    }

    const loadReplacements = () => {
        setLoading(true);
        SftGlobalData.post('rma&action=replacements', {key: props.api}).then(response => {
            if(typeof response.error === 'undefined'){
                setReplacements(response.data);
                let tempArr = [];
                response.data.forEach(element => {
                    if(!tempArr.includes(element.type))
                        tempArr.push(element.type);
                });
                setReplacementTypes(tempArr);
            } else { 
                props.notify(props.t('errorOccured'), 7500, "top-center", props.theme, 1);
            }
            setLoading(false);
        });
    }

    const loadStores = () => {
        SftGlobalData.post('sftData', {type: "stores", key: props.api}).then(response => {
            setStores(response.data.data);
        });
    }

    const handleChange = (event, newValue) => { setValue(newValue);};

    const getModalContent = () => {
        switch(modalContent){
            case "New replacement":
            case "Edit replacement":
                return (<div className='rowContainerBetween _100perc'>
                            <div className='columnContainerStart _100perc ' style={{textAlign: "left", marginBottom: 10, width: "50%"}}>
                                <TextField
                                    className={props.theme+ '_accent _100perc margin_right__10px margin_bottom_10px'}
                                    label="Name"
                                    value={replacementName}
                                    onChange={(event)=>{
                                        setReplacementName(event.target.value);
                                    }}
                                    variant="outlined"
                                    style={{height: 43}}
                                    sx={(props.theme==='light') ? {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.light_text
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: Colors.sft_blue
                                        }} 
                                        :
                                        {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.dark_text
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: Colors.sft_blue
                                            }}}
                                  />
                                <TextField
                                    className={props.theme+ '_accent _100perc margin_right__10px margin_bottom_10px'}
                                    label="Type"
                                    value={replacementType}
                                    onChange={(event)=>{
                                        setReplacementType(event.target.value);
                                    }}
                                    variant="outlined"
                                    style={{height: 43}}
                                    sx={(props.theme==='light') ? {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.light_text
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: Colors.sft_blue
                                        }} 
                                        :
                                        {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.dark_text
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: Colors.sft_blue
                                            }}}
                                  />
                                <TextField
                                    className={props.theme+ '_accent _100perc margin_right__10px margin_bottom_10px'}
                                    label="Serial number"
                                    value={replacementSerial}
                                    onChange={(event)=>{
                                        setReplacementSerial(event.target.value);
                                    }}
                                    variant="outlined"
                                    style={{height: 43}}
                                    sx={(props.theme==='light') ? {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.light_text
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: Colors.sft_blue
                                        }} 
                                        :
                                        {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.dark_text
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: Colors.sft_blue
                                            }}}
                                />
                                <FormControl className={props.theme+ '_accent margin_bottom_10px'}>
                                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                                  <Select
                                    className={props.theme+"_accent "+props.theme+"_text _100perc"}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={replacementStatus}
                                    label="Status"
                                    onChange={(event)=>{const {target: { value },} = event; setReplacementStatus(value);}}
                                    style={{height: 43, paddingTop: 8, paddingBottom: 8}}>
                                        <MenuItem value="35000"><span className='green_text'>AVAILABLE</span></MenuItem>
                                        <MenuItem value="35001"><span className='error_text'>UNAVAILABLE</span></MenuItem>
                                        <MenuItem value="35002"><span className='error_text'>MISSING</span></MenuItem>
                                        <MenuItem value="35003"><span className='error_text'>DEFECT</span></MenuItem>
                                        <MenuItem value="35004"><span className='error_text'>SOLD</span></MenuItem>
                                        <MenuItem value="35005"><span className='error_text'>DELETED</span></MenuItem>
                                  </Select>
                                </FormControl>
                                <TextField
                                    multiline
                                    minRows={5}
                                    maxRows={5}
                                    autoComplete="off" 
                                    className={props.theme+ '_accent log__100_perc'}
                                    id="remark"
                                    label={props.t('remark')}
                                    size={'small'}
                                    sx={(props.theme==='light') ? {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.light_text
                                          },
                                        '& .MuiInputLabel-root': {
                                            color: Colors.light_text
                                         }, borderRadius: 3, marginTop: 0} 
                                        :
                                        {
                                        '& .MuiOutlinedInput-input': {
                                            color: Colors.dark_text
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: Colors.dark_text_accent
                                            }, borderRadius: 3, marginTop: 0}}
                                    value={replacementRemark}
                                    onChange={(event)=>{setReplacementRemark(event.target.value)}}
                                />  
                            </div>
                            <div className="columnContainerStart" style={{width: "50%"}}>
                                <div className='rowContainerCenter _100perc ' style={{textAlign: "left", marginBottom: 10}}>
                                    <div className='icon'>
                                        <img alt="Replacement image" src={"data:image/jpeg;base64," + replacementImage}  style={{objectFit: 'contain', height: 285, width: 285}} loading={"lazy"} />
                                    </div>
                                </div>
                                <div className='rowContainerCenter _100perc ' style={{textAlign: "left", marginBottom: 10}}>
                                    <input style={{width: 500}} type="file" className="form-control" name="image" onChange={onImageChange}  accept="image/jpeg, image/png, image/jpg"/>
                                </div>
                            </div>
                        </div>)
            default: 
                return <div>TEST</div>
        }
    }

    const onImageChange = (e) => {
        let files = e.target.files;
        let file = files[0];
        let fileReader = new FileReader();

        fileReader.readAsDataURL(file);
 
        fileReader.onload = (event) => {
            if (SftGlobalData.debug) {
                console.log("image", event.target.result);
            }
    
            const base64Image = event.target.result;
            const img = new Image();
            img.src = base64Image;
    
            img.onload = () => {
                const MAX_SIZE_MB = 0.6;
                const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
    
                const resizeImage = (image, quality) => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    const scale = Math.sqrt(MAX_SIZE_BYTES / (image.width * image.height * 4)); // assuming 4 bytes per pixel
                    canvas.width = image.width * scale;
                    canvas.height = image.height * scale;
                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                    return canvas.toDataURL('image/jpeg', quality);
                };
    
                let resizedBase64Image = base64Image;
                let quality = 0.92; // starting quality for jpeg compression
    
                while (resizedBase64Image.length * (3 / 4) > MAX_SIZE_BYTES && quality > 0.1) {
                    resizedBase64Image = resizeImage(img, quality);
                    quality -= 0.05; // reduce quality to further compress the image
                }
    
                setReplacementImage(resizedBase64Image.replace(/^data:image\/[a-zA-Z]+;base64,/, ''));
            };
        };
    }

    const SaveReplacement = (id) => {
        let postData = {
            key: props.api,
            id: id,
            name: replacementName,
            type: replacementType,
            serial_number: replacementSerial,
            remark: replacementRemark,
            status: replacementStatus,
            image: replacementImage
        }
        SftGlobalData.post('rma&action=saveReplacement', postData).then(response => {
            setModalOpen(false);
            loadReplacements();
        });
    }

    const SaveNewReplacement = () => {
        let postData = {
            key: props.api,
            name: replacementName,
            type: replacementType,
            serial_number: replacementSerial,
            remark: replacementRemark,
            status: replacementStatus,
            image: replacementImage
        }
        SftGlobalData.post('rma&action=addReplacement', postData).then(response => {
            setModalOpen(false);
            loadReplacements();
        });
    }

    const handleRowClick = (params) => {
        if(SftGlobalData.debug) console.log('Row clicked:', params.row);
        navigate("/"+props.lang+"/rma/detail/"+params.row.id);
    };

    const skeletonAnim = "wave";

    return (
        <div className={(props.hideSidebar? ' not_expanded _100perc ' : ' expanded _80perc ') + 'container_content ' + props.theme + ' container_content_' + props.theme } style={{width: props.hideSidebar?"100%":"80%"}}>
            <StyledModal
                aria-labelledby="unstyled-modal-title"
                aria-describedby="unstyled-modal-description"
                open={modalStoresOpen}
                onClose={()=>{setModalStoresOpen(false)}}
                BackdropComponent={Backdrop}
                >
                <Box sx={style}  style={{minWidth: 300, minHeight: 300, width: 500}} className={props.theme + "  box_fade-in"}>
                    <div className='columnContainerBetween' style={{width: "100%", height: "100%", minHeight: 300}}>
                        <h2>Create RMA</h2>
                        <FormControl sx={{ width: '100%', marginTop: 1, marginBottom: 3, marginRight: 1, textAlign: "left" }}>
                            <InputLabel id="demo-chip-label" className={props.theme+"_accent "+props.theme+"_text border_radius_top"}>Store</InputLabel>
                            <Select
                            style={{marginBottom:10}}
                            className={props.theme+"_accent "+props.theme+"_text"}
                            labelId="demo-chip-label"
                            id="demo-chip"
                            label={"store"}
                            value={selectedStore}
                            onChange={(e) => { setSelectedStore(e.target.value)}}
                            >
                            <MenuItem value={"00"}><em>None</em></MenuItem>
                            {stores.map((store) => (
                                <MenuItem
                                key={store.code}
                                value={store.code}
                                >
                                    {store.code+" - "+store.oms}
                                </MenuItem>
                            ))}
                            </Select>

                        </FormControl>
                        <Button
                            sx={{ borderRadius: 2, border: '1px solid ' + Colors.sft_blue, color: Colors.sft_blue, width: "100%", marginBottom: 5 }}
                            variant="outlined"
                            onClick={() => { navigate("/"+props.lang+"/rma/detail/add/"+selectedStore); }}
                        >
                            CREATE
                        </Button>
                    </div>
                </Box>
            </StyledModal>
            <StyledModal
                aria-labelledby="unstyled-modal-title"
                aria-describedby="unstyled-modal-description"
                open={modalOpen}
                onClose={()=>{setModalOpen(false)}}
                BackdropComponent={Backdrop}
                >
                <Box sx={style}  style={{minWidth: 750, minHeight: 500, width: "90%"}} className={props.theme + "  box_fade-in"}>
                    <h2>{modalContent}</h2>
                    <hr/>
                    {getModalContent()}
                    <br/><br/>
                    <Button type="button" className={"button_container__button _100perc"} onClick={()=>{modalContent === "Edit replacement" ? SaveReplacement(modalTarget.id) : SaveNewReplacement();}}>&nbsp;{props.t('save')}&nbsp;</Button>
                </Box>
            </StyledModal>
            <div className={"container_list__title " + props.theme}><h2>RMA's</h2></div>
            {loading && <Box sx={{ width: "100%", marginTop: 10, height: 300}}>
                <div className='rowContainerStart'>
                    <Skeleton animation={skeletonAnim} style={{width: 150, height: 60, marginRight: 10}}/>
                    <Skeleton animation={skeletonAnim} style={{width: 150, height: 60, marginRight: 10}}/>
                    <Skeleton animation={skeletonAnim} style={{width: 150, height: 60, marginRight: 10}}/>
                </div>
                <Skeleton animation={skeletonAnim} style={{width: "100%", height: 3, marginRight: 10, marginTop: -8}} />
                <Skeleton animation={skeletonAnim} style={{width: "100%", height: 60, marginRight: 10, marginTop: 0}} /> 
                <Skeleton animation={skeletonAnim} style={{width: "100%", height: 300, marginRight: 10, marginTop: -65}} /> 
            </Box>}
            {(!loading && dbVersion >= minDB) && <div className='rowContainerCenter _100perc'>
                <Box className={props.theme + ' licence__enivronment'}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className={props.theme + ' container_tabs_below_subtitle'}>
                      <Tabs value={value} onChange={handleChange} className={props.theme} variant="scrollable" scrollButtons="auto">
                        <Tab label={"OPEN RMA "} {...a11yProps(0)} className={props.theme}/>
                        <Tab label={"CLOSED RMA "} {...a11yProps(1)} className={props.theme}/>                
                        <Tab label={"REPLACEMENTS "} {...a11yProps(2)} className={props.theme}/>            
                      </Tabs>
                  </Box>
                  
                  <TabPanel value={value} index={0}>
                        <div>
                            <input 
                                //ref={inputEl}
                                type="text"
                                name="search"
                                className={props.theme+"_accent "}
                                style={{width: "100%"}}
                                placeholder={props.t('search')}
                                value={searchValue}
                                autoFocus
                                onChange={e => {setSearchValue(e.target.value.replace("+", "").replace("\\", "")); /*sessionStorage.removeItem('search'); sessionStorage.setItem('search', e.target.value.replace("+", "").replace("\\", ""));*/}}
                                onFocus={(event) => event.target.select()}
                                
                            />
                            <div className='rowContainerCenter _100perc' style={{maxHeight: 500}}>
                                <DataGridPro
                                      //apiRef={apiRef}
                                      //initialState={initialGrid}
                                      className={'excel_grid ' + props.theme}
                                      columns={[
                                        {
                                            field: 'id',
                                            headerName: 'ID',
                                            minWidth: 50,
                                            maxWidth: 50,
                                            width: 50,
                                            align: "left",
                                            display: 'flex',      
                                        },
                                        {
                                            field: 'customer',
                                            headerName: "Customer",
                                            minWidth: 200,
                                            align: "left",
                                            display: 'flex',      
                                        },
                                        {
                                            field: 'firmanaam',
                                            headerName: "Company",
                                            minWidth: 220,
                                            align: "left",
                                            display: 'flex',      
                                        },
                                        {
                                            field: 'article',
                                            headerName: "Article",
                                            minWidth: 350,
                                            align: "left",
                                            display: 'flex',      
                                        },
                                        /*{
                                            field: 'serial_number',
                                            headerName: "Serial number",
                                            minWidth: 165,
                                            align: "left",
                                        },*/
                                        {
                                            field: 'rma_status',
                                            headerName: "Status",
                                            minWidth: 150,
                                            align: "left",
                                            display: 'flex',      
                                            renderCell: (params) => {
                                                return <div>{getRmaStatus(params.row.rma_status)}</div>;
                                            }
                                        },
                                        {
                                            field: 'supplier_status',
                                            headerName: "Supplier status",
                                            minWidth: 150,
                                            align: "left",
                                            display: 'flex',      
                                            renderCell: (params) => {
                                                return <div>{getSupplierStatus(params.row.supplier_status)}</div>;
                                            }
                                        },
                                        {
                                            field: 'assigned_user_name',
                                            headerName: "Assigned to",
                                            minWidth: 200,
                                            align: "left",
                                            display: 'flex',      
                                        },
                                        /*{
                                            field: 'created_at',
                                            headerName: "Created at",
                                            minWidth: 165,
                                            align: "left",
                                        },*/
                                        {
                                            field: 'updated_at',
                                            headerName: "Updated at",
                                            minWidth: 165,
                                            align: "left",
                                            display: 'flex',      
                                        },
                                      ]}
                                      rows={rma.filter(row => ( row.klnr.match(new RegExp("^" + searchValue.slice(0, -1) + "$", 'i')) ||
                                                                searchValue.substring(searchValue.length - 1) !== "*" && (
                                                                row.assigned_user_name.match(new RegExp(searchValue, "i")) || 
                                                                (row.customer?.naam + " " + row.customer?.firstname + " " + row.customer?.firmanaam).match(new RegExp(searchValue, "i")) || 
                                                                row.barcode.match(new RegExp(searchValue, "i")) || 
                                                                row.article.match(new RegExp(searchValue, "i")) || 
                                                                row.remark.match(new RegExp(searchValue, "i")) || 
                                                                row.created_at.match(new RegExp(searchValue, "i")) || 
                                                                row.rma_status.match(new RegExp(searchValue, "i")) || 
                                                                row.supplier_rma_id.match(new RegExp(searchValue, "i")) || 
                                                                row.serial_number.match(new RegExp(searchValue, "i")) || 
                                                                row.klnr.match(new RegExp(searchValue, "i")) || 
                                                                row.id.match(new RegExp(searchValue, "i")) || 
                                                                row.ticketnr.match(new RegExp(searchValue, "i"))) 
                                                              )).map((row, index) => {return {
                                            id: row.id,
                                            assigned_user_name: row.assigned_user_name,
                                            barcode: row.barcode,
                                            article: row.article,
                                            remark: row.remark,
                                            customer: row.customer?.naam + " " + row.customer?.firstname,
                                            firmanaam: row.customer?.firmanaam,
                                            klnr: row.klnr,
                                            created_at: row.created_at,
                                            replacement_id: row.replacement_id,
                                            replacement_from: row.replacement_from,
                                            replacement_until: row.replacement_until,
                                            rma_status: row.rma_status,
                                            serial_number: row.serial_number,
                                            supplier_rma_id: row.supplier_rma_id,
                                            supplier_status: row.supplier_status,
                                            ticketnr: row.ticketnr,
                                            updated_at: row.updated_at,
                                            warranty_until: row.warranty_until,
                                        }                          
                                    })} 
                                      //onColumnWidthChange={()=>{visibilityChangedHandler();}}
                                      //onColumnVisibilityModelChange={()=>{visibilityChangedHandler();}}
                                      //onPreferencePanelClose={()=>{visibilityChangedHandler();}}
                                      rowThreshold={0}
                                      rowHeight={38}
                                      loading={loading}
                                      pagination={true}
                                      style={{minHeight: 300}}
                                      onRowClick={handleRowClick}
                                /> 
                            </div>
                            <FloatingAddButton disabled={loading} onClick={()=>{ if(stores.length === 1) navigate("/"+props.lang+"/rma/detail/add/"+stores[0].code); else setModalStoresOpen(true);}} />
                        </div>
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                      <div>
                        <input 
                            //ref={inputEl}
                            type="text"
                            name="search"
                            className={props.theme+"_accent "}
                            style={{width: "100%"}}
                            placeholder={props.t('search')}
                            value={searchValue}
                            autoFocus
                            onChange={e => {setSearchValue(e.target.value.replace("+", "").replace("\\", "")); /*sessionStorage.removeItem('search'); sessionStorage.setItem('search', e.target.value.replace("+", "").replace("\\", ""));*/}}
                            onFocus={(event) => event.target.select()}
                            
                        />
                        <div className='rowContainerCenter _100perc' style={{maxHeight: 500}}>
                            <DataGridPro
                                  //apiRef={apiRef}
                                  //initialState={initialGrid}
                                  className={'excel_grid ' + props.theme}
                                  columns={[
                                    {
                                        field: 'id',
                                        headerName: 'ID',
                                        minWidth: 100,
                                        maxWidth: 100,
                                        width: 100,
                                        align: "left",
                                    },
                                    {
                                        field: 'customer',
                                        headerName: "Customer",
                                        minWidth: 200,
                                        align: "left",
                                    },
                                    {
                                        field: 'barcode',
                                        headerName: "Article",
                                        minWidth: 165,
                                        align: "left",
                                    },
                                    {
                                        field: 'serial_number',
                                        headerName: "Serial number",
                                        minWidth: 165,
                                        align: "left",
                                    },
                                    {
                                        field: 'rma_status',
                                        headerName: "Status",
                                        minWidth: 150,
                                        align: "left",
                                        renderCell: (params) => {
                                            return <div>{getRmaStatus(params.row.rma_status)}</div>;
                                        }
                                    },
                                    {
                                        field: 'supplier_status',
                                        headerName: "Supplier status",
                                        minWidth: 150,
                                        align: "left",
                                        renderCell: (params) => {
                                            return <div>{getSupplierStatus(params.row.supplier_status)}</div>;
                                        }
                                    },
                                    {
                                        field: 'created_at',
                                        headerName: "Created at",
                                        minWidth: 165,
                                        align: "left",
                                    },
                                    {
                                        field: 'updated_at',
                                        headerName: "Updated at",
                                        minWidth: 165,
                                        align: "left",
                                    },
                                  ]}
                                  rows={rmaClosed.filter(row => ( row.klnr.match(new RegExp("^" + searchValue.slice(0, -1) + "$", 'i')) ||
                                          searchValue.substring(searchValue.length - 1) !== "*" && (
                                          row.assigned_user_name.match(new RegExp(searchValue, "i")) || 
                                          (row.customer?.naam + " " + row.customer?.firstname).match(new RegExp(searchValue, "i")) || 
                                          row.barcode.match(new RegExp(searchValue, "i")) || 
                                          row.remark.match(new RegExp(searchValue, "i")) || 
                                          row.created_at.match(new RegExp(searchValue, "i")) || 
                                          row.rma_status.match(new RegExp(searchValue, "i")) || 
                                          row.supplier_rma_id.match(new RegExp(searchValue, "i")) || 
                                          row.serial_number.match(new RegExp(searchValue, "i")) || 
                                          row.klnr.match(new RegExp(searchValue, "i")) || 
                                          row.id.match(new RegExp(searchValue, "i")) || 
                                          row.ticketnr.match(new RegExp(searchValue, "i"))) 
                                        )).map((row, index) => {return {
                                        id: row.id,
                                        assigned_user_name: row.assigned_user_name,
                                        barcode: row.barcode,
                                        remark: row.remark,
                                        customer: row.customer?.naam + " " + row.customer?.firstname,
                                        klnr: row.klnr,
                                        created_at: row.created_at,
                                        replacement_id: row.replacement_id,
                                        replacement_from: row.replacement_from,
                                        replacement_until: row.replacement_until,
                                        rma_status: row.rma_status,
                                        serial_number: row.serial_number,
                                        supplier_rma_id: row.supplier_rma_id,
                                        supplier_status: row.supplier_status,
                                        ticketnr: row.ticketnr,
                                        updated_at: row.updated_at,
                                        warranty_until: row.warranty_until,
                                    }                          
                                })} 
                                  //onColumnWidthChange={()=>{visibilityChangedHandler();}}
                                  //onColumnVisibilityModelChange={()=>{visibilityChangedHandler();}}
                                  //onPreferencePanelClose={()=>{visibilityChangedHandler();}}
                                  rowThreshold={0}
                                  rowHeight={38}
                                  loading={loading}
                                  pagination={true}
                                  style={{minHeight: 300}}
                                  onRowClick={handleRowClick}
                            /> 
                        </div>
                    </div>
                  </TabPanel>
                  <TabPanel value={value} index={2}>
                        <div className='environment__card_body_container' style={{marginTop: 5}}>
                            <FloatingAddButton disabled={loading} onClick={()=>{
                                                                                            setModalContent("New replacement");
                                                                                            setModalTarget({});
                                                                                            setReplacementName("");
                                                                                            setReplacementType("");
                                                                                            setReplacementStatus("35000");
                                                                                            setReplacementSerial("");
                                                                                            setReplacementImage("");
                                                                                            setReplacementRemark("");
                                                                                            setModalOpen(true);
                                                                                        }} />

                            {replacementTypes.map((type) => {
                                return (
                                    <div className='_100perc' style={{paddingBottom: 20}}>
                                        <h3>&nbsp;{type}</h3>
                                        <hr/>
                                        <div className='rowContainerStart' style={{overflowX: "auto", paddingBottom: 20}}>
                                            {replacements.filter(row => (row.type === type)).map((replacement) => (
                                                <div style={{minWidth: 275}}>
                                                    
                                                    <Card func={()=>{}} theme={props.theme} style={{maxWidth: 250, width: 250, height: 320, maxHeight: 320}}>
                                                        
                                                        <div className='icon rowContainerCenter'>
                                                            <img alt="Replacement image" src={"data:image/jpeg;base64," + (replacement?.image !== "" ? replacement.image : brokenImage)}  style={{objectFit: 'contain', height: 200, width: 200}} loading={"lazy"} />
                                                        </div>
                                                        <div className='environment__card_body' style={{textAlign: "center"}}>
                                                            <p className='environment__text_body text_center _100perc bold'>{replacement.name}</p>
                                                            {/*<p className='environment__text_body text_center'>{replacement.type}</p>*/}
                                                            <p className='environment__text_body text_center'>&nbsp;{replacement.serial_number}&nbsp;</p>
                                                            <p className='environment__text_body text_center bigger_text'>{getReplacementStatus(replacement.status)}</p>
                                                        </div>
                                                    </Card>
                                                    <Box disabled={false} onClick={()=>{}} style={{float: "right", zIndex: 2, marginLeft: -35, marginTop: 295}}>
                                                      <Fab size="medium" color={"warning"} aria-label="edit" onClick={()=>{
                                                                                                            setModalContent("Edit replacement"); 
                                                                                                            setModalTarget(replacement); 
                                                                                                            setReplacementName(replacement.name);
                                                                                                            setReplacementType(replacement.type);
                                                                                                            setReplacementStatus(replacement.status);
                                                                                                            setReplacementSerial(replacement.serial_number);
                                                                                                            setReplacementImage(replacement.image);
                                                                                                            setReplacementRemark(replacement.remark);
                                                                                                            setModalOpen(true);
                                                                                                        }}
                                                        >
                                                        <EditIcon />
                                                      </Fab>
                                                    </Box>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )
                            })}
                            
                        </div>
                  </TabPanel>
                </Box>
          </div>}
          {( !loading && dbVersion < minDB) && <div><p style={{textAlign: "center"}} className='error_text'>DB Version {minDB} required.</p></div>}
        </div>
    );
}

export default RMAScreen;
